import React, { useEffect, useState } from 'react';
import { FaTachometerAlt, FaUser } from 'react-icons/fa';
import { dashboardUrl } from '../../config/app';
import { checkAuthStatus, hasLoginMarker } from '../../lib/auth';
import './AuthButton.css';

export function useAuthStatus({ enabled = true } = {}) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;

    let cancelled = false;

    const refreshAuth = (force = false) => {
      if (hasLoginMarker()) {
        setIsAuthenticated(true);
      }

      checkAuthStatus({ force }).then((loggedIn) => {
        if (!cancelled) setIsAuthenticated(loggedIn);
      });
    };

    refreshAuth(false);

    const handleFocus = () => refreshAuth(true);
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') refreshAuth(true);
    };

    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      cancelled = true;
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [enabled]);

  return isAuthenticated;
}

export default function AuthButton({ className = '', onNavigate, authenticated }) {
  const detectedAuth = useAuthStatus({ enabled: typeof authenticated !== 'boolean' });
  const isAuthenticated = typeof authenticated === 'boolean' ? authenticated : detectedAuth;
  const target = isAuthenticated ? dashboardUrl('/') : dashboardUrl('/login');

  return (
    <a
      href={target}
      className={`auth-header-btn ${className}`.trim()}
      onClick={onNavigate}
    >
      {isAuthenticated ? <FaTachometerAlt /> : <FaUser />}
      <span>{isAuthenticated ? 'Dashboard' : 'Login'}</span>
    </a>
  );
}
